



















import {Component, Vue} from "vue-property-decorator";
import BaseOverview, {Loadable} from "@/resources/components/BaseOverview.vue";
import Brand from '@/app/models/Brand';

@Component({
    components: {
        "base-overview": BaseOverview,
    },
})
export default class Index extends Vue {
    async loadItems(loadable: Loadable) {
        loadable.loadItems(
            (await Brand.index(loadable.page, {production_order_id: this.$route.params.productionOrder})).data
        );
    }
}
